<template>
  <div
      :class="[theme, isActiveClassname]"
      class="dialog"
  >
    <div
	    :class="[position, direction]"
	    class="dialog__item"
    >
      <slot></slot>
      <div class="button-wrapper flex--justify-between">
        <div
            @click="confirm"
            class="button button--icon button--h-25 bg--greeny-blue"
        >
          <i class="fas fa-save"></i>
        </div>
        <div
            @click="cancel"
            class="button button--icon button--h-25"
        >
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {clickOutside} from '@/directives/click-outside';
import {computed} from 'vue';

export default {
  directives: {
    clickOutside
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'dark' // ['', 'dark']
    },
    position: {
      type: String,
      default: 'middle' // start, middle, end
    },
    direction: {
      type: String,
      default: 'bottom' // ['left', 'bottom', 'top', 'right']
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  emits: ['confirm', 'cancel'],
  setup(props, {emit}) {
    const isActiveClassname = computed(() => props.active ? 'active' : '');

    function confirm(){
      emit('confirm');
    }
    function cancel(){
      emit('cancel');
    }

    return {
      isActiveClassname,
      confirm,
      cancel,
    }
  }
}
</script>

<style lang="scss">
@use "@/scss/items/dialog/dialog";
</style>
